import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { FormattedMessageProps } from '../../messages';

export const IsValidOrLoading = ({
	isValidating,
	siteNameValue,
	validationMessage,
}: {
	isValidating: boolean;
	siteNameValue: string;
	validationMessage?: FormattedMessageProps;
}) => {
	if (siteNameValue === '') {
		return null;
	}
	if (isValidating) {
		return <Spinner size="small" testId="spinner" />;
	}
	if (validationMessage) {
		return <WarningIcon label="warning" color={token('color.icon.danger')} />;
	}
	return <CheckCircleIcon label="success" color={token('color.icon.accent.lime')} />;
};
